import axios from 'axios'

const baseUrl = '/votes'

export function asyncGetQuestions (id) {
  return new Promise(function (resolve, reject) {
    axios.get(`${baseUrl}/${id}`).then(r => resolve(r.data))
  })
}

export function asyncPushResult (id, answer) {
  return new Promise(function (resolve, reject) {
    axios.post(`${baseUrl}/${id}`, {
      answer: answer
    }).then(r => resolve(r.data))
  })
}



// WEBPACK FOOTER //
// ./src/backend.js